export const sharedBlueprintRoutes = [
  {
    path: 'shared/:token',
    lazy: () => import('./[SharedBlueprint]/[SharedBlueprint]'),
  },
];
